import * as i0 from "@angular/core";
var NavbarService = /** @class */ (function () {
    function NavbarService() {
        this.navbarOpen = false;
    }
    NavbarService.ngInjectableDef = i0.defineInjectable({ factory: function NavbarService_Factory() { return new NavbarService(); }, token: NavbarService, providedIn: "root" });
    return NavbarService;
}());
export { NavbarService };
